'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './speaker-edit.routes';

export class SpeakerEditComponent {
  constructor(SpeakerService, dialogs, User, $stateParams, $state, $localStorage, Auth) {
    'ngInject';
    this.Auth = Auth;
    this.SpeakerService = SpeakerService;
    this.dialogs = dialogs;
    this.$localStorage = $localStorage;

    this.$state = $state;

    this.Auth.getCurrentUser(user => {

      this.speaker = {
        businessType: this.$localStorage.businessType,
        businessYears: this.$localStorage.businessYears,
        familyInfo: this.$localStorage.familyInfo,
        previousJobs: this.$localStorage.previousJobs,
        hobbies: this.$localStorage.hobbies,
        likeToMeet: this.$localStorage.likeToMeet,
        burningDesire: this.$localStorage.burningDesire,
        ifIDidntIWould: this.$localStorage.ifIDidntIWould,
        noOneKnows: this.$localStorage.noOneKnows,
        meta: {
          creationUser: user._id
        }
      };

      this.valid = true;
      this.speakerId = $stateParams.id;

      this.title = (this.speakerId) ? "Edit" : "Sign Up";

      let now = (new Date()).getTime();

      this.dates = [];
      SpeakerService.query(data => {

        data.forEach(speaker => {
          /* If edit and same id, do not consider date to include */
          if (this.speakerId && this.speakerId == speaker._id)
            return;

          if (new Date(speaker.date).getTime() > now)
            this.dates.push(speaker.date);
        })

      });

      if (this.speakerId) {
        this.SpeakerService.get({id: this.speakerId}, data => {
          this.speaker = data;
          this.speaker.date = new Date(data.date);
        }, err => {
          console.log('Could not load speaker from server');
        })
      }

    })
  }

  checkDate() {

    let newValid = true;

    let date = new Date(this.speaker.date);
    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();

    console.log("enter", date, day, month, year);

    this.dates.forEach(takenDate => {

      let _date = new Date(takenDate);
      let _day = _date.getDate();
      let _month = _date.getMonth();
      let _year = _date.getFullYear();

      if (_day == day && _month == month && _year == year) {
        newValid = false;
      }
    });

    this.valid = newValid;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      this.$localStorage.businessType = this.speaker.businessType;
      this.$localStorage.businessYears = this.speaker.businessYears;
      this.$localStorage.familyInfo = this.speaker.familyInfo;
      this.$localStorage.previousJobs = this.speaker.previousJobs;
      this.$localStorage.hobbies = this.speaker.hobbies;
      this.$localStorage.likeToMeet = this.speaker.likeToMeet;
      this.$localStorage.burningDesire = this.speaker.burningDesire;
      this.$localStorage.ifIDidntIWould = this.speaker.ifIDidntIWould;
      this.$localStorage.noOneKnows = this.speaker.noOneKnows;

      var onSuccess = () => {
        var actionString = (this.speakerId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The speaker has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("speaker-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.speakerId) {  // Save changes on the current speaker
        this.SpeakerService.update({id: this.speakerId}, this.speaker, onSuccess, onError);
      } else { // Create new settings
        this.SpeakerService.save(this.speaker, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduuApp.speakerEdit', [uiRouter])
  .config(routes)
  .component('speakerEdit', {
    template: require('./speaker-edit.html'),
    controller: SpeakerEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/speaker/edit/speaker-edit.component.js